<template>
    <el-dialog
        title="查看"
        :visible.sync="workMessExamine"
        width="1000px" :close-on-click-modal="false">
        <div class="examine">
            <h2>报名信息</h2>
            <div class="examineList">
                <p class="examineList_title">报名时间 :</p>
                <p>{{ sign.createTime }}</p>
            </div>
            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap" class="examineList_title">昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称 :</p>
                    <p>{{ sign.nickName }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap" class="examineList_title">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名 :</p>
                    <p>{{ sign.name }}</p>
                </div>
            </div>

            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p style="white-space:nowrap" class="examineList_title">联系电话:</p>
                    <p>{{ sign.tel }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p class="examineList_title">参赛主体 :</p>
                    <p>{{ sign.signTypeCn }}</p>
                </div>
            </div>

            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p class="examineList_title">单位/院校 :</p>
                    <p>{{ sign.teamName }}</p>
                </div>
                <div class="examineListTwo_box">
                    <p class="examineList_title">指导老师 :</p>
                    <p>{{ sign.teamMember }}</p>
                </div>
            </div>
        </div>
        <div class="examine">
            <h2>作品信息</h2>
            <div class="examineList">
                <p class="examineList_title">赛道名称 :</p>
                <p>{{ info.activityWayName }}</p>
            </div>
            <div class="examineList">
                <p class="examineList_title">作品类别 :</p>
                <p>{{ info.typeName }}</p>
            </div>
            <div class="examineList">
                <p class="examineList_title">作品封面 :</p>
                <img :src="info.coverUrl" alt="">
            </div>

            <div class="examineList">
                <p class="examineList_title">作品名称 :</p>
                <p>{{ info.name }}</p>
            </div>

            <div class="examineList" v-if="info.code">
                <p class="examineList_title">作品编号 :</p>
                <p>{{ info.code }}</p>
            </div>

            <div class="examineList">
                <p class="examineList_title">作品简介 :</p>
                <p v-html="info.summary" class="examineHtml vHtmlMess"></p>
            </div>
            <!--<div class="examineList">
                <p>参赛作品 :</p>
                <p style="color: #1890FF;cursor: pointer;" @click="downloadFile(info.worksUrl,info.worksName)">{{ info.worksName }}</p>
            </div>-->
            <div class="examineList">
                <p class="examineList_title">作品说明 :</p>
                <p v-html="info.description" style="margin:0" class="vHtmlMess"></p>
            </div>
            <!--<div class="examineList">
                <p style="white-space:nowrap">附&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;件 :</p>
                <p style="color: #1890FF;cursor: pointer;" @click="downloadFile(info.videoUrl,info.videoName)">{{ info.videoName }}</p>
            </div>-->
            <div class="examineList">
                <p style="white-space:nowrap" class="examineList_title">参赛作品 :</p>
                <div class="winWorksMess_box">
                  <p  style="color: #1890FF;cursor: pointer;"
                      class="winWorksMess"
                      v-for="(item,index) in worksFileList"
                      :key="index"
                      @click="downloadFile(item.url,item.name)">
                      {{ item.name }}
                  </p>
                </div>

            </div>
        </div>
        <div class="examine">
          <h2>评分信息</h2>
          <div class="examineList2 examineListTwo">
            <div class="examineListTwo_box">
              <p class="examineList_title">投票数量:</p>
              <p>{{ info.voteNum }}</p>
            </div>
            <div class="examineListTwo_box" v-if="info.isVote && info.voteScore>0">
              <p class="examineList_title">投票得分:</p>
              <p>{{ info.voteScore }}</p>
            </div>
          </div>
          <div class="examineList2 examineListTwo" v-if="info.isJudges && info.reviewStatus=='PASS'">
            <div class="examineListTwo_box">
                <p class="examineList_title">评委评分:</p>
                <p>{{ info.score }}</p>
            </div>
          </div>
            <div class="examineList2 examineListTwo">
                <div class="examineListTwo_box">
                    <p class="examineList_title">作品总分:</p>
                    <p>{{ (info.score+info.voteScore).toFixed(2) }}</p>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import { getWorksDetail } from '../../utils/interface';
    export default {
        name: "examineDialog",
        data() {
            return{
                workMessExamine: false,
                info:{},
                sign:{},
                worksFileList:[],
            }
        },
        methods: {
            init(uuid) {
                this.resetData();
                this.workMessExamine = true;
                getWorksDetail(uuid).then((res)=>{
                    this.info = res.info;
                    this.sign = res.sign;
                    this.worksFileList = this.info.worksFileList;
                });
            },
            resetData(){
                this.info = {};
                this.sign = {};
                this.worksFileList = [];
            },
            downloadFile(fileUrl,fileName){
                this.validate.downLoadNameFile(fileUrl,fileName)
            },
        }
    }
</script>

<style scoped lang="less">
/deep/.el-dialog__body {
  padding-top: 0;
}
.examine {
  h2 {
      font-weight: 700;
      font-size: 16px;
      color: #000;
      margin-top: 26px;
      letter-spacing: 1px;
  }
  .examineList {
    display: flex;
    img {
      width: 300px;
      height: 150px;
    }
    .examineList_title{
      margin-right: 16px;
      width: 65px;
      flex-shrink: 0;
    }
    .examineHtml {
      /deeep/img {
        max-width: 100%;
      }
    }
    .winWorksMess_box {
      // display: flex;
      // flex-wrap: wrap;
      .winWorksMess {
        margin-right: 16px;
      }
    }

  }
  .examineListTwo {
    display: flex;
    align-items: center;
    .examineListTwo_box {
      display: flex;
      align-items: center;
      width: 50%;
    }
  }
  .examineList2 {
    display: flex;
    align-items: center;
    p:nth-of-type(1){
      margin-right: 16px;
      width: 105px;
    }
  }
  .examineList_mess {

  }
    /deep/img { max-width: 100% }
}
</style>



// WEBPACK FOOTER //
// src/views/active/worksDetailsDialog.vue